import { MDBRow} from "mdbreact";
import React from "react";
import IconOne from "../../../../new_images/Landing/Icons/Icon_n1.png";
import IconTwo from "../../../../new_images/Landing/Icons/Icon_n2.png";
import IconThree from "../../../../new_images/Landing/Icons/Icon_n3.png";
import IconFour from "../../../../new_images/Landing/Icons/Icon_n4.png";
import "./HowUse.css"


class Disfruta extends React.Component {
  render() {
    return (
      <section className="text-left my-5">
      <p
        className="p_titulo mb-3"
      >
        ¿Cómo usar Tovo siendo pasajero?
      </p>

      <div style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "10px"
                }}>
        <div className="view-DisfrutaPasajero col-lg-11" >
          <MDBRow>
            <MDBRow around style={{width:"100%"}}>
              <div className="col-lg-2" >
                <div className="img_num">
                <img src={IconOne} height="70px" alt="servicio de calidad" style={{marginTop: "10px", marginBottom: "10px"}} /> 
              </div>
              </div>
              <div className="col-lg-3" >
                <p className="p_title">Instala la app y regístrate</p>
              </div>
              <div className="col-lg-5" >
                <p className="p_texto">Descarga la app, registra tu información de perfil y sube la documentación solicitada, espera la verificación y ¡comienza!</p>
              </div>
            </MDBRow>
            <MDBRow around style={{width:"100%"}}>
              <div className="col-lg-2" >
                <div className="img_num">
                <img src={IconTwo} height="70px" alt="servicio de calidad" style={{marginTop: "10px", marginBottom: "10px"}} /> 
              </div>
              </div>
              <div className="col-lg-3" >
                <p className="p_title">Descubre los viajes que Tovo te ofrece</p>
              </div>
              <div className="col-lg-5" >
                <p className="p_texto">En Tovo encontrarás miles de viajes, utiliza los filtros para encontrar aquellos que más se adaptan a tus necesidades y solicita una reserva</p>
              </div>
            </MDBRow>
            <MDBRow around style={{width:"100%"}}>
              <div className="col-lg-2" >
                <div className="img_num">
                <img src={IconThree} height="70px" alt="servicio de calidad" style={{marginTop: "10px", marginBottom: "10px"}} /> 
              </div>
              </div>
              <div className="col-lg-3" >
                <p className="p_title">Conoce al conductor</p>
              </div>
              <div className="col-lg-5" >
                <p className="p_texto">Cuando el conductor acepte tu solicitud ponte en contacto con él para definir el punto de encuentro.</p>
              </div>
            </MDBRow>
            <MDBRow around style={{width:"100%"}}>
              <div className="col-lg-2" >
                <div className="img_num">
                <img src={IconFour} height="70px" alt="servicio de calidad" style={{marginTop: "10px", marginBottom: "10px"}} /> 
              </div>
              </div>
              <div className="col-lg-3" >
                <p className="p_title">¡Súbete y disfruta del viaje!</p>
              </div>
              <div className="col-lg-5" >
                <p className="p_texto">Goza de un viaje cómodo y seguro, contribuye a la reducción de CO2 y ayuda al medio ambiente.</p>
              </div>
            </MDBRow>
          </MDBRow>   
        </div>
      </div>
    </section>
    );
  }
}

export default Disfruta;
